"use strict";

PF.Field.Slider = class Slider extends  PF.Field
{


    static get options()
    {
        return {
            html: PF.Field.Slider.templates,
            model: new PF.Model({}),
            key: 'value',


            min: -Infinity,
            max: Infinity,
            type: 'range', //dual
            step: 1,
            // orientation: horizontal, //vertical
        };
    }

    static get templates()
    {
        return {
            //language=HTML
            wrapper: `            
                <div class="pf-slider-wrapper">
                    <div class="innerBlock" pf="innerBlock">
                        <div class="center range-slider range-slider-init " pf='pf-slider-center'>
                            <label pf="label"></label>
                            <input type="text" pf="input"/>
                        </div>
                    </div>
                </div>
        `,
        };
    }

    init()
    {

        super.init();
        this.dom.loads(this.html);

        this.dom.element.append(this.dom.wrapper);

        this.dom.input.bindValue();

        // this.onChange(["model." + this.min, "model." + this.max], () =>
        // {
        //     this.diapason = {
        //         min: this.model.get(this.min),
        //         max: this.model.get(this.max)
        //     };

        // }, true);

    }

}